import { defineMessages } from "react-intl";

export default defineMessages({
  // title: {
  //   id: "app.components.CardResultDisciplineContent.title",
  //   defaultMessage: "Content"
  // },
  averageScoreCriterion: {
    id: "app.components.CardResultDisciplineContent.averageScoreCriterion",
    defaultMessage: "Average score by assessment criterion"
  }
});
